<template>
    <ModalRouteChild :parent="parent" resume>
        <SectionTitle
            :title="config.CONTRACT_TITLE"
            :description="config.CONTRACT_DESCRIPTION"
        />
        <SectionPicture>
            <ArtContract :color="config.COLOR_PRIMARY"/>
        </SectionPicture>
        <section class="checkbox">
            <Checkbox v-model="signed">
                <!-- WARN potentially dangerous in case of misconfig, intentional or not -->
                <small v-html="config.CONTRACT_RIGHTS"/>
            </Checkbox>
        </section>
        <SectionActions>
            <Button :color="config.COLOR_PRIMARY" :to="{ name: next }" :disabled="!signed">
                {{ config.CONTRACT_CTA }}
            </Button>
        </SectionActions>
    </ModalRouteChild>
</template>
<script>
import { SolutionConsumer } from '../../mixins';
import { ModalRouteChild } from '../../components/desktop';
import {
    SectionPicture, SectionTitle, SectionActions,
} from '../../components/shared';

export default {
    name: 'ContractModal',
    components: {
        ModalRouteChild, SectionPicture, SectionTitle, SectionActions,
    },
    mixins: [SolutionConsumer],
    props: {
        parent: {
            type: String,
            default: 'deposit.brief',
        },
        next: {
            type: String,
            default: 'deposit.upload',
        },
    },
    data () {
        return {
            signed: false,
        };
    },
};
</script>
